import './GlowCircleIcon.scss'

export default function GlowCircleIcon({ color, size = 1.1, className }) {
	return (
		<div
			className={`glow-circle ${className}`}
			style={{ backgroundColor: color, '--size': `${size}rem`, boxShadow: '0 0 5px rgba(0, 0, 0, 0.5)' }}></div>
	)
}
